import { EntityLinks, GoalProgressCount } from '@griply/types';
import { GoalParentKind, resolveGoalParents } from '@griply/utils';
import { IconFormNames } from 'shared/assets/icons';
import { Paths } from 'shared/routes/paths';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';
import { getCompletionPercentage } from 'shared/utils/get-completion-percentage';
import { getGoalCompletion } from 'shared/utils/get-goal-completion';
import { getGoalDetailUrl } from 'shared/utils/get-goal-detail-url';

export type GoalBreadcrumbItem = {
  id: ID;
  name: string;
  path: string;
  percentage: number;
  hasProgress: boolean;
  iconName?: IconFormNames | null;
};

export type GetGoalBreadcrumbParentsOptions = {
  goals: Goal[];
  lifeAreas: LifeArea[];
  links: EntityLinks;
  goalProgressCounts?: Map<ID, GoalProgressCount>;
};

export const getGoalBreadcrumbParents = (
  goal: Goal,
  {
    goals,
    lifeAreas,
    links,
    goalProgressCounts,
  }: GetGoalBreadcrumbParentsOptions,
): GoalBreadcrumbItem[] =>
  resolveGoalParents(goal, { goals, lifeAreas, links }).map((parent) => {
    if (parent.kind === GoalParentKind.LifeArea) {
      return {
        id: parent.lifeArea.id,
        name: parent.lifeArea.name,
        path: Paths.LifeAreaDetail.replace(':id', parent.lifeArea.id),
        percentage: 0,
        hasProgress: false,
        iconName: parent.lifeArea.iconName,
      };
    }

    const { start, current, end } = getGoalCompletion(parent.goal, {
      goalProgressCounts,
    });

    return {
      id: parent.goal.id,
      name: parent.goal.name,
      path: getGoalDetailUrl(parent.goal),
      percentage: getCompletionPercentage({ start, current, end }),
      hasProgress: end !== Infinity && !parent.goal.completedAt,
      iconName: parent.goal.iconName,
    };
  });
